import Configuration from './Configuration';
import SessionManager from './SessionManager';

const weapiUrl = Configuration.serviceUrl;

const language = SessionManager.language;
const currencyFormatter = Intl.NumberFormat(SessionManager.language, { style: "currency", currency: SessionManager.currency, minimumFractionDigits: 2 });
const unitPriceFormatter = Intl.NumberFormat(SessionManager.language, { style: "currency", currency: SessionManager.currency, minimumFractionDigits: 5 });
const dateFormatter = Intl.DateTimeFormat(SessionManager.language, { month: "numeric", day: "numeric", year: "numeric" });

export function GetUserName(data) {
    if (data) {
        return JSON.parse(data).name;
    }
}

export function GetUserId(data) {
    if (data) {
        return JSON.parse(data).id;
    }
}

export function GetSalesId(data) {
    if (data) {
        return JSON.parse(data).salesPointId;
    }
}

export function GetPriceListId(data) {
    if (data) {
        return JSON.parse(data).priceListid;
    }
}

//Second way for the above with 2 properties
export function GetUserData(data, field) {
    if (data && field) {
        return JSON.parse(data)[field];
    }
}

//Check if the user is Loged In
export function IsUserLogedIn() {
    return localStorage.hasOwnProperty('userData') ? true : false;
}

export function Logout(){
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('lastActiveTime');
    window.location.href = '/dashboard';
}

//Create Urls
export function CreateGetUrl(connectionName, version, entityName, pk, filter, join, select, orderby, count, top, authenticationToken, username) {
    let url = weapiUrl + 'data/' + connectionName + '/' + version;

    url = url + '/' + entityName;

    if (pk) {
        url = url + '(' + pk + ')?';
    }
    else {
        url = url + '?';
    }

    if (filter) {
        url = url + 'filter=' + filter + '&';
    }
    if (join) {
        url = url + 'join=' + join + '&';
    }
    if (select) {
        url = url + 'select=' + select + '&';
    }
    if (orderby) {
        url = url + 'orderby=' + orderby + '&';
    }
    if (count) {
        url = url + 'count=' + count + '&';
    }
    if (top) {
        url = url + 'top=' + top + '&';
    }

    url = `${url}authenticationToken=${authenticationToken}&username=${username}`;

    return url;
}

export function CreateDeletePutUrl(connectionName, version, entityName, pk, authenticationToken, username) {
    let url = weapiUrl + 'data/' + connectionName + '/' + version;

    url = url + '/' + entityName + '(' + pk + ')?';

    url = `${url}authenticationToken=${authenticationToken}&username=${username}`;

    return url;
}

export function CreatePostUrl(controller, connectionName, version, entityName, authenticationToken, username) {
    let url = weapiUrl + controller + '/' + connectionName + '/' + version;

    if (entityName) {
        url = url + '/' + entityName;
    }

    if (authenticationToken && username) {
        url = `${url}?authenticationToken=${authenticationToken}&username=${username}`;
    }

    return url;
}

export function CreateMetadataUrl(connectionName, version, entityName, authenticationToken, username) {
    let url = weapiUrl + 'data/' + connectionName + '/' + version + '/EntityMetadata';

    url = url + '/' + entityName + '?';

    url = `${url}authenticationToken=${authenticationToken}&username=${username}`;

    return url;
}

export function CreateUserUnlockUrl(connectionName, version) {
    let url = weapiUrl + 'admin/' + connectionName + '/' + version + '/unlock';

    return url;
}

// get json responses
export function getMetadataProperties(metadata) {
    let results = {};

    if (metadata.Properties) {
        metadata = metadata.Properties;
        for (var i in metadata) {
            results[metadata[i].Name] = metadata[i].Caption;
        }
    }

    return results;
}

export function getEntityResults(inputJson) {
    let tempJson = {};
    let results = {};
    let resultList = [];

    if (inputJson.Results) {
        for (var i in inputJson.Results) {
            tempJson = inputJson.Results[i];

            for (var key in tempJson) {
                results[key] = tempJson[key];
            }

            resultList.push(results);
            results = {};
        }
    }
    else {
        return inputJson;
    }

    return resultList;
}

// Shorthand null guard function for the ? ternary operator
export function val(value, defaultValue) {
  return value ? value : defaultValue;
}

export function formatCurrency(_amount, _NaNText) {
    if (isNaN(_amount))
        return _NaNText ? _NaNText : "";
    else 
        return currencyFormatter.format(_amount);
}

export function formatUnitPrice(_amount) {
    if (isNaN(_amount))
        return "";
    else 
        return unitPriceFormatter.format(_amount);
}

export function formatDate(_date) {

    if (!_date)
        return "";
    
    return dateFormatter.format(Date.parse(_date));
}

/**
 * Formats a date / time value to an ISO8601 string
 * @param _date The date to format
 * @returns An ISO8601 date / time string
 */
export function formatDateTimeISO(_date) {
    if (typeof _date === "Date") {
        return `${_date.getFullYear()}-${_date.getMonth() + 1}-${_date.getDate()}T${_date.getUTCHours()}:${_date.getUTCMinutes()}:${_date.getUTCSeconds()}`;
    }
    else {
        return null;
    }
}

export function getCookieValue(_cookieName) {
    let result = document.cookie.match("(^|[^;]+)\\s*" + _cookieName + "\\s*=\\s*([^;]+)")
    return result ? result.pop() : null;
}

export function setCookieValue(_cookieName, _value, _expiration) {
    if (!_expiration)
        _expiration = formatDate(Date.now() + 1);
    
    document.cookie = `${_cookieName}=${_value}; expires=${formatDateTimeISO(_expiration)}`;
}

export function getBaseUrl() {
    return `${window.location.protocol}//${window.location.host}/`;
}
